import type { documentSchema } from '@ecomm/contentful-schemas'
import { useCurrentPromo } from '@ecomm/promotions-hooks'
import { HeroBanner as HeroBannerComponent } from '@ecomm/shared-components/lib/HeroBanner'
import type { HeroBannerSchema } from '@ecomm/shared-components/lib/HeroBanner/schema'
import { useMediaQuery } from '@ecomm/shared-hooks'
import type { TypeOf } from '@simplisafe/ewok'

import { modifyDescription } from './helper'

type DocumentSchema = TypeOf<typeof documentSchema>

export function HeroBanner({
  heroBannerProps,
  location = ''
}: {
  readonly heroBannerProps: HeroBannerSchema
  readonly location?: string
}) {
  const isDesktop = useMediaQuery('DesktopAndUp')

  const { heroStickerImage } = useCurrentPromo()

  const [heroBannerColumn] = [...heroBannerProps.contentCollection.items]

  const newDescription: DocumentSchema = modifyDescription(
    // @ts-expect-error - TODO: fix this
    heroBannerColumn,
    location
  )

  const newHeroBannerColumn = {
    ...heroBannerColumn,
    description: {
      // @ts-expect-error - TODO: fix this
      ...heroBannerColumn.description,
      json: newDescription
    }
  }

  const props = {
    ...heroBannerProps,
    contentCollection: {
      items: [newHeroBannerColumn]
    }
  }

  return (
    // @ts-expect-error - TODO: fix this
    <HeroBannerComponent
      {...props}
      className="prose-h1:my-9 prose-h1:max-w-xs prose-h1:font-arizona prose-h1:text-heading-1-size prose-h1:md:mt-1 prose-h1:lg:mt-9 prose-h1:lg:max-w-xl prose-h1:lg:text-[65px] prose-h1:lg:tracking-[-0.01em]"
      heroStickerImage={heroStickerImage}
      isFullWidth={isDesktop ? heroBannerProps.isFullWidth : true}
      roundedCorners={!!isDesktop}
    />
  )
}
